import { Component, OnInit, Input } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { V3ServicesService } from "src/app/core/services/v3-services.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UploadGalleryComponent } from "src/app/shared/ui/upload-gallery/upload-gallery.component";

@Component({
  selector: "app-category-banner",
  templateUrl: "./category-banner.component.html",
  styleUrls: ["./category-banner.component.scss"],
})
export class CategoryBannerComponent {
  @Input() country;
  @Input() page;
  bannerForm: FormGroup;
  hasChanges: boolean;
  expertData: any;
  isUpdating: boolean;
  isSubmitted: boolean;
  isNew = false;

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private api: V3ServicesService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.resetForm();
    this.getData();
  }

  resetForm(data?) {
    this.bannerForm = this.fb.group({
      id: [data ? data.id : null],
      country: [this.country],
      web_banner: [data ? data?.web_banner : ""],
      mob_banner: [data ? data?.mob_banner : ""],
      banner_link: [data ? data?.banner_link : ""],
    });
    this.onChanges();
  }

  onChanges(): void {
    this.bannerForm.valueChanges.subscribe(() => {
      Object.keys(this.bannerForm.controls).map((key) => {
        if (this.bannerForm.get(key).dirty) this.hasChanges = true;
      });
    });
  }

  getData() {
    this.api.getCountryBanner(this.country).subscribe((result: any) => {
      this.isNew = result.length == 0;
      this.expertData = result[0] || null;
      this.resetForm(this.expertData);
    });
  }

  openUploadModal(field) {
    const modalRef = this.modalService.open(UploadGalleryComponent, {
      size: "xl",
      scrollable: true,
      windowClass: "modal-big-lg",
      keyboard: false,
      backdrop: "static",
    });
    modalRef.componentInstance.uploadDetails = {};
    modalRef.result.then((result) => {
      if (result.status) {
        this.bannerForm.get(field).setValue(result.image);
      }
    });
  }

  onSubmit(form) {
    if (form.valid) {
      this.isUpdating = true;

      if (this.isNew) {
        this.api.setCountryBanner(form.value).subscribe(
          (result: any) => {
            this.resetForm(result);
            this.toastr.success("Content Added Successfully!");
            this.hasChanges = false;
            this.isUpdating = false;
            this.isNew = false;
          },
          () => {
            this.isUpdating = false;
          }
        );
      } else {
        this.api.updateCountryBanner(form.value.id, form.value).subscribe(
          (result: any) => {
            this.resetForm(result);
            this.toastr.success("Content Updated Successfully!");
            this.hasChanges = false;
            this.isUpdating = false;
          },
          () => {
            this.isUpdating = false;
          }
        );
      }
    }
  }
}
